module.exports = __webpack_public_path__ + "img/at-svg.6ca62b67.svg";